module.exports = __webpack_public_path__ + "img/hk-bottom.419eb16a.png";